import type { HTMLAttributes, ReactNode } from 'react'

export function FormRow({ children, className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`ui-row ${className}`.trim()} {...props}>
      {children}
    </div>
  )
}

export interface FormFieldProps extends HTMLAttributes<HTMLDivElement> {
  label?: ReactNode
  htmlFor?: string
  variant?: 'grow' | 'full' | 'w80' | 'w100' | 'w140' | 'w180' | 'w200'
}

export function FormField({ label, htmlFor, children, className = '', variant, ...props }: FormFieldProps) {
  const baseClass = 'ui-field'
  const variantClass = variant ? `ui-field--${variant}` : ''

  return (
    <div className={`${baseClass} ${variantClass} ${className}`.trim()} {...props}>
      {label && (
        <label htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
    </div>
  )
}
